import { render, staticRenderFns } from "./NewServiceDialog.vue?vue&type=template&id=34f5381a&scoped=true&"
import script from "./NewServiceDialog.vue?vue&type=script&lang=js&"
export * from "./NewServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewServiceDialog.vue?vue&type=style&index=0&id=34f5381a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5381a",
  null
  
)

export default component.exports